export default "__VITE_ASSET__DP0ZP9HM__"